import { Card, SpecialPriceType } from '../../../ActivityDetails.types'

export const getCorporateSpecial = (purchaseOption: Card) =>
  purchaseOption.specialPrices.find((specialPrice) => specialPrice.type === SpecialPriceType.CORPORATE_EMPLOYEES)
